import {
  CountryCmsListRepo,
  getCountryCmsOverviewRepo,
  putCountryCmsOverviewRepo,
  deleteCountryCmsOverviewRepo,
  getCountryCmsCurrencyLanguagesRepo,
  getCountryCmsFaqsRepo,
  putCountryCmsFaqsRepo,
  getCountryCmsBasicDetailsRepo,
  putCountryCmsBasicDetailsRepo,
  getCountryCmsPopularPlacesRepo,
  getCountryCmsContentDetailsRepo,
  putCountryCmsContentDetailsRepo,
  getCountryCmsMediaRepo,
  putCountryCmsMediaRepo,
} from "../repositories/premium/country";
import { createSlice } from "@reduxjs/toolkit";
const countrySlice = createSlice({
  name: "countryReducer",
  initialState: {
    countryListLoading: null,
    countryListData: null,
    countryListError: null,
    deleteCountryListLoading: null,
    deleteCountryListData: null,
    deleteCountryListError: null,
    countryOverviewLoading: null,
    countryOverviewData: null,
    countryOverviewError: null,
    putCountryOverviewLoading: null,
    putCountryOverviewData: null,
    putCountryOverviewError: null,
    countryCurrencyLanguagesLoading: null,
    countryCurrencyLanguagesData: null,
    countryCurrencyLanguagesError: null,
    countryPopularPlacesStatesLoading: null,
    countryPopularPlacesStatesData: null,
    countryPopularPlacesStatesError: null,
    countryPopularPlacesCollegesLoading: null,
    countryPopularPlacesCollegesData: null,
    countryPopularPlacesCollegesError: null,
    countryBasicDetailLoading: null,
    countryBasicDetailData: null,
    countryBasicDetailError: null,
    putCountryBasicDetailLoading: null,
    putCountryBasicDetailData: null,
    putCountryBasicDetailError: null,
    countryContentDetailLoading: null,
    countryContentDetailData: null,
    countryContentDetailError: null,
    putCountryContentDetailLoading: null,
    putCountryContentDetailData: null,
    putCountryContentDetailError: null,
    countryFaqLoading: null,
    countryMediaData: null,
    countryMediaError: null,
    countryMediaLoading: null,
    putCountryMediaLoading: null,
    putCountryMediaData: null,
    putCountryMediaError: null,
    countryFaqData: null,
    countryFaqError: null,
    putCountryFaqLoading: null,
    putCountryFaqData: null,
    putCountryFaqError: null,
    message:null,
  },
  reducers: {
    getCountryListLoading(state, action) {
      return {
        ...state,
        countryListLoading: true,
      };
    },
    getCountryListSuccess(state, action) {
      return {
        ...state,
        countryListLoading: false,
        countryListData: action.payload,
      };
    },
    getCountryListFailure(state, action) {
      return {
        ...state,
        countryListLoading: false,
        countryListError: action.payload,
      };
    },
    deleteCountryListLoading(state, action) {
      return {
        ...state,
        deleteCountryListLoading: true,
        message:null
      };
    },
    deleteCountryListSuccess(state, action) {
      return {
        ...state,
        deleteCountryListLoading: false,
        deleteCountryListData: action.payload,
        message: "Country Details Deleted Successfully",
      };
    },
    deleteCountryListFailure(state, action) {
      return {
        ...state,
        deleteCountryListLoading: false,
        deleteCountryListError: action.payload,
        message: "Failure in Deleted Course Details",
      };
    },
    cleardeleteCountryList(state,action){
      return {
        ...state,
        deleteCountryListData: null,
        deleteCountryListError: null,
        message:null
      };
    },
    getCountryOverviewLoading(state, action) {
      return {
        ...state,
        countryOverviewLoading: true,
      };
    },
    getCountryOverviewSuccess(state, action) {
      return {
        ...state,
        countryOverviewLoading: false,
        countryOverviewData: action.payload,
      };
    },
    getCountryOverviewFailure(state, action) {
      return {
        ...state,
        countryOverviewLoading: false,
        countryOverviewError: action.payload,
      };
    },
    putCountryOverviewLoading(state, action) {
      return {
        ...state,
        putCountryOverviewLoading: true,
        message:null,
      };
    },
    putCountryOverviewSuccess(state, action) {
      return {
        ...state,
        putCountryOverviewLoading: false,
        putCountryOverviewData: action.payload,
        message: "Overview Details Added Successfully",
      };
    },
    putCountryOverviewFailure(state, action) {
      return {
        ...state,
        putCountryOverviewLoading: false,
        putCountryOverviewError: action.payload,
        message: "Failure in Adding Overview Details",
      };
    },
    getCountryCurrencyLanguagesLoading(state, action) {
      return {
        ...state,
        countryCurrencyLanguagesLoading: true,
      };
    },
    getCountryCurrencyLanguagesSuccess(state, action) {
      return {
        ...state,
        countryCurrencyLanguagesLoading: false,
        countryCurrencyLanguagesData: action.payload,
      };
    },
    getCountryCurrencyLanguagesFailure(state, action) {
      return {
        ...state,
        countryCurrencyLanguagesLoading: false,
        countryCurrencyLanguagesError: action.payload,
      };
    },
    getCountryPopularPlacesStatesLoading(state, action) {
      return {
        ...state,
        countryPopularPlacesStatesLoading: true,
      };
    },
    getCountryPopularPlacesStatesSuccess(state, action) {
      return {
        ...state,
        countryPopularPlacesStatesLoading: false,
        countryPopularPlacesStatesData: action.payload,
      };
    },
    getCountryPopularPlacesStatesFailure(state, action) {
      return {
        ...state,
        countryPopularPlacesStatesLoading: false,
        countryPopularPlacesStatesError: action.payload,
      };
    },
    getCountryPopularPlacesCollegesLoading(state, action) {
      return {
        ...state,
        countryPopularPlacesCollegesLoading: true,
      };
    },
    getCountryPopularPlacesCollegesSuccess(state, action) {
      return {
        ...state,
        countryPopularPlacesCollegesLoading: false,
        countryPopularPlacesCollegesData: action.payload,
      };
    },
    getCountryPopularPlacesCollegesFailure(state, action) {
      return {
        ...state,
        countryPopularPlacesCollegesLoading: false,
        countryPopularPlacesCollegesError: action.payload,
      };
    },
    clearCountryOverview(state, action) {
      return {
        countryOverviewData: null,
        countryOverviewLoading: false,
        message:null
      };
    },
    getCountryBasicDetailLoading(state, action) {
      return {
        ...state,
        countryBasicDetailLoading: true,
      };
    },
    getCountryBasicDetailSuccess(state, action) {
      return {
        ...state,
        countryBasicDetailLoading: false,
        countryBasicDetailData: action.payload,
      };
    },
    getCountryBasicDetailFailure(state, action) {
      return {
        ...state,
        countryBasicDetailLoading: false,
        countryBasicDetailError: action.payload,
      };
    },
    putCountryBasicDetailLoading(state, action) {
      return {
        ...state,
        putCountryBasicDetailLoading: true,
        message:null
      };
    },
    putCountryBasicDetailSuccess(state, action) {
      return {
        ...state,
        putCountryBasicDetailLoading: false,
        putCountryBasicDetailData: action.payload,
        message:"Basic Details Added Successfully"
      };
    },
    putCountryBasicDetailFailure(state, action) {
      return {
        ...state,
        putCountryBasicDetailLoading: false,
        putCountryBasicDetailError: action.payload,
        message: "Failure in Adding Basic Details",
      };
    },
    clearCountryBasicDetail(state, action) {
      return {
        countryBasicDetailData: null,
        countryBasicDetailLoading: false,
        message:null
      };
    },
    getCountryContentDetailLoading(state, action) {
      return {
        ...state,
        countryContentDetailLoading: true,
      };
    },
    getCountryContentDetailSuccess(state, action) {
      return {
        ...state,
        countryContentDetailLoading: false,
        countryContentDetailData: action.payload,
      };
    },
    getCountryContentDetailFailure(state, action) {
      return {
        ...state,
        countryContentDetailLoading: false,
        countryContentDetailError: action.payload,
      };
    },
    putCountryContentDetailLoading(state, action) {
      return {
        ...state,
        putCountryContentDetailLoading: true,
        message:null
      };
    },
    putCountryContentDetailSuccess(state, action) {
      return {
        ...state,
        putCountryContentDetailLoading: false,
        putCountryContentDetailData: action.payload,
        message: "Content Details Added Successfully",
      };
    },
    putCountryContentDetailFailure(state, action) {
      return {
        ...state,
        putCountryContentDetailLoading: false,
        putCountryContentDetailError: action.payload,
        message: "Failure in Adding Content Details",
      };
    },
    clearCountryContentDetail(state, action) {
      return {
        countryContentDetailData: null,
        countryContentDetailLoading: false,
        message:null
      };
    },
    getCountryMediaLoading(state, action) {
      return {
        ...state,
        countryMediaLoading: true,
      };
    },
    getCountryMediaSuccess(state, action) {
      return {
        ...state,
        countryMediaLoading: false,
        countryMediaData: action.payload,
      };
    },
    getCountryMediaFailure(state, action) {
      return {
        ...state,
        countryMediaLoading: false,
        countryMediaError: action.payload,
      };
    },
    putCountryMediaLoading(state, action) {
      return {
        ...state,
        putCountryMediaLoading: true,
        message:null
      };
    },
    putCountryMediaSuccess(state, action) {
      return {
        ...state,
        putCountryMediaLoading: false,
        putCountryMediaData: action.payload,
        message: "Media Added Successfully",
      };
    },
    putCountryMediaFailure(state, action) {
      return {
        ...state,
        putCountryMediaLoading: false,
        putCountryMediaError: action.payload,
        message: "Failure in Adding Media Details",
      };
    },
    clearCountryMedia(state, action) {
      return {
        countryMediaData: null,
        countryMediaLoading: false,
        message:null
      };
    },
    getCountryFaqLoading(state, action) {
      return {
        ...state,
        countryFaqLoading: true,
      };
    },
    getCountryFaqSuccess(state, action) {
      return {
        ...state,
        countryFaqLoading: false,
        countryFaqData: action.payload,
      };
    },
    getCountryFaqFailure(state, action) {
      return {
        ...state,
        countryFaqLoading: false,
        countryFaqError: action.payload,
      };
    },
    putCountryFaqLoading(state, action) {
      return {
        ...state,
        putCountryFaqLoading: true,
        message:null
      };
    },
    putCountryFaqSuccess(state, action) {
      return {
        ...state,
        putCountryFaqLoading: false,
        putCountryFaqData: action.payload,
        message: "Faq Added Successfully",
      };
    },
    putCountryFaqFailure(state, action) {
      return {
        ...state,
        putCountryFaqLoading: false,
        putCountryFaqError: action.payload,
        message: "Failure in Adding Faq",
      };
    },
    clearCountryFaq(state, action) {
      return {
        countryFaqData: null,
        countryFaqLoading: false,
        message:null
      };
    },
  },
});
export const {
  getCountryListLoading,
  getCountryListSuccess,
  getCountryListFailure,
  deleteCountryListLoading,
  deleteCountryListSuccess,
  deleteCountryListFailure,
  cleardeleteCountryList,
  getCountryOverviewLoading,
  getCountryOverviewSuccess,
  getCountryOverviewFailure,
  putCountryOverviewLoading,
  putCountryOverviewSuccess,
  putCountryOverviewFailure,
  getCountryCurrencyLanguagesLoading,
  getCountryCurrencyLanguagesSuccess,
  getCountryCurrencyLanguagesFailure,
  getCountryPopularPlacesStatesLoading,
  getCountryPopularPlacesStatesSuccess,
  getCountryPopularPlacesStatesFailure,
  getCountryPopularPlacesCollegesLoading,
  getCountryPopularPlacesCollegesSuccess,
  getCountryPopularPlacesCollegesFailure,
  clearCountryOverview,
  getCountryBasicDetailLoading,
  getCountryBasicDetailSuccess,
  getCountryBasicDetailFailure,
  putCountryBasicDetailLoading,
  putCountryBasicDetailSuccess,
  putCountryBasicDetailFailure,
  clearCountryBasicDetail,
  getCountryContentDetailLoading,
  getCountryContentDetailSuccess,
  getCountryContentDetailFailure,
  putCountryContentDetailLoading,
  putCountryContentDetailSuccess,
  putCountryContentDetailFailure,
  clearCountryContentDetail,
  getCountryMediaLoading,
  getCountryMediaSuccess,
  getCountryMediaFailure,
  putCountryMediaLoading,
  putCountryMediaSuccess,
  putCountryMediaFailure,
  clearCountryMedia,
  getCountryFaqLoading,
  getCountryFaqSuccess,
  getCountryFaqFailure,
  putCountryFaqLoading,
  putCountryFaqSuccess,
  putCountryFaqFailure,
  clearCountryFaq,
} = countrySlice.actions;
export const getCountryList = (params) => {
  return async (dispatch) => {
    dispatch(getCountryListLoading());
    await CountryCmsListRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getCountryListSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCountryListFailure(error.message));
        }
      });
  };
};
export const deleteCountryList = (params) => {
  return async (dispatch) => {
    dispatch(deleteCountryListLoading());
    await deleteCountryCmsOverviewRepo(params)
      .then((response) => {
        if (response?.status == 200 ) {
          dispatch(deleteCountryListSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(deleteCountryListFailure(error.message));
        }
      });
  };
};
export const getCountryOverview = (params) => {
  return async (dispatch) => {
    dispatch(getCountryOverviewLoading());
    await getCountryCmsOverviewRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getCountryOverviewSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCountryOverviewFailure(error.message));
        }
      });
  };
};
export const putCountryOverview = (params, data) => {
  return async (dispatch) => {
    dispatch(putCountryOverviewLoading());
    await putCountryCmsOverviewRepo(params, data)
      .then((response) => {
        if (response?.status == 201) {
          dispatch(putCountryOverviewSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(putCountryOverviewFailure(error.message));
        }
      });
  };
};
export const getCountryCurrencyLanguage = (params) => {
  return async (dispatch) => {
    dispatch(getCountryCurrencyLanguagesLoading());
    await getCountryCmsCurrencyLanguagesRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getCountryCurrencyLanguagesSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCountryCurrencyLanguagesFailure(error.message));
        }
      });
  };
};
export const getCountryPopularPlacesStates = (params) => {
  return async (dispatch) => {
    dispatch(getCountryPopularPlacesStatesLoading());
    await getCountryCmsPopularPlacesRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getCountryPopularPlacesStatesSuccess(response?.data?.data?.states_list));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCountryPopularPlacesStatesFailure(error.message));
        }
      });
  };
};

export const getCountryPopularPlacesColleges = (params) => {
  return async (dispatch) => {
    dispatch(getCountryPopularPlacesCollegesLoading());
    await getCountryCmsPopularPlacesRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getCountryPopularPlacesCollegesSuccess(response?.data?.data));
          // dispatch(getCountryPopularPlacesCollegesSuccess({state:{id:params.state_id},colleges:params.colleges}));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCountryPopularPlacesCollegesFailure(error.message));
        }
      });
  };
};
export const getCountryBasicDetail = (params) => {
  return async (dispatch) => {
    dispatch(getCountryBasicDetailLoading());
    await getCountryCmsBasicDetailsRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getCountryBasicDetailSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCountryBasicDetailFailure(error.message));
        }
      });
  };
};
export const putCountryBasicDetail = (params, data) => {
  return async (dispatch) => {
    dispatch(putCountryBasicDetailLoading());
    await putCountryCmsBasicDetailsRepo(params, data)
      .then((response) => {
        if (response?.status == 201) {
          dispatch(putCountryBasicDetailSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(putCountryBasicDetailFailure(error.message));
        }
      });
  };
};
export const getCountryContentDetail = (params) => {
  return async (dispatch) => {
    dispatch(getCountryContentDetailLoading());
    await getCountryCmsContentDetailsRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getCountryContentDetailSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCountryContentDetailFailure(error.message));
        }
      });
  };
};
export const putCountryContentDetail = (params, data) => {
  return async (dispatch) => {
    dispatch(putCountryContentDetailLoading());
    await putCountryCmsContentDetailsRepo(params, data)
      .then((response) => {
        if (response?.status == 201) {
          dispatch(putCountryContentDetailSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(putCountryContentDetailFailure(error.message));
        }
      });
  };
};
export const getCountryMedia = (params) => {
  return async (dispatch) => {
    dispatch(getCountryMediaLoading());
    await getCountryCmsMediaRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getCountryMediaSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCountryMediaFailure(error.message));
        }
      });
  };
};
export const putCountryMedia = (params, data) => {
  return async (dispatch) => {
    dispatch(putCountryMediaLoading());
    await putCountryCmsMediaRepo(params, data)
      .then((response) => {
        if (response?.status == 201) {
          dispatch(putCountryMediaSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(putCountryMediaFailure(error.message));
        }
      });
  };
};
export const getCountryFaq = (params) => {
  return async (dispatch) => {
    dispatch(getCountryFaqLoading());
    await getCountryCmsFaqsRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getCountryFaqSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCountryFaqFailure(error.message));
        }
      });
  };
};
export const putCountryFaq = (params, data) => {
  return async (dispatch) => {
    dispatch(putCountryFaqLoading());
    await putCountryCmsFaqsRepo(params, data)
      .then((response) => {
        if (response?.status == 201) {
          dispatch(putCountryFaqSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(putCountryFaqFailure(error.message));
        }
      });
  };
};
export default countrySlice.reducer;
